import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#e95d3f',
      contrastText: '#110c0a',
    },
    secondary: {
      main: '#f2b84b',
      contrastText: '#110c0a',
    },
    background: {
      default: '#0b0909',
      paper: '#15110f',
    },
    text: {
      primary: '#f8f1e7',
      secondary: '#c9beb2',
    },
  },
  typography: {
    fontFamily: '"Manrope", sans-serif',
    h1: {
      fontFamily: '"Bebas Neue", sans-serif',
      fontWeight: 400,
      letterSpacing: 0,
    },
    h2: {
      fontFamily: '"Bebas Neue", sans-serif',
      fontWeight: 400,
      letterSpacing: 0,
    },
    h3: {
      fontFamily: '"Bebas Neue", sans-serif',
      fontWeight: 400,
      letterSpacing: 0,
    },
    h4: {
      fontFamily: '"Bebas Neue", sans-serif',
      fontWeight: 400,
      letterSpacing: 0,
    },
    button: {
      fontFamily: '"Manrope", sans-serif',
      fontWeight: 700,
      letterSpacing: 0,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 48,
          borderRadius: 3,
          paddingInline: 22,
          boxShadow: 'none',
          transition: 'background-color 180ms ease, color 180ms ease, transform 180ms ease',
          '&:hover': {
            boxShadow: 'none',
            transform: 'translateY(-2px)',
          },
          '&:focus-visible': {
            outline: '3px solid #f2b84b',
            outlineOffset: 3,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '3px solid #f2b84b',
            outlineOffset: 3,
          },
        },
      },
    },
  },
});

export default theme;
